import { useEffect, useState } from 'react';

export const useDateNow = () => {
  const [dateNow, setDateNow] = useState<Date>(new Date());

  useEffect(() => {
    const oneMinute = 60000;

    const intervalId = setInterval(() => {
      setDateNow(new Date());
    }, oneMinute);

    return () => clearInterval(intervalId);
  }, []);

  return { dateNow };
};
